import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import SelectWrap from '../../components/SelectWrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import DaysTable from './components/DaysTable';
import DaysCountryTable from './components/DaysCountryTable';
import PeriodTable from './components/PeriodTable';
import PeriodCountryTable from './components/PeriodCountryTable';
import API from '../../services/API';
import countriesObj from "../../data/countries";
import { prepareDaysReport, prepareDaysCountryReport, preparePeriodReport, preparePeriodCountryReport } from "./prepareReport";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class BidderECost extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            subid: [],
            device: '',
            countries: [],
            rawReport: null,
            daysReport: null,
            daysCountryReport: null,
            periodReport: null,
            periodCountryReport: null,
            reportType: 'days',
            days: [],
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        API.BidderNetworkPerformance.getAffids().then(affids => this.setState({ affidValues: affids }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { reportType, rawReport, daysReport, daysCountryReport, periodReport, periodCountryReport } = nextState;

        if(rawReport) {
            if(reportType === 'days' && !daysReport) {
                const newDaysReport = prepareDaysReport(rawReport);

                this.setState({ daysReport: newDaysReport });
            }
            if(reportType === 'daysCountry' && !daysCountryReport) {
                const newDaysCountryReport = prepareDaysCountryReport(rawReport);

                this.setState({ daysCountryReport: newDaysCountryReport });
            }
            if(reportType === 'period' && !periodReport) {
                const newPeriodReport = preparePeriodReport(rawReport);

                this.setState({ periodReport: newPeriodReport });
            }
            if(reportType === 'periodCountry' && !periodCountryReport) {
                const newPeriodCountryReport = preparePeriodCountryReport(rawReport);

                this.setState({ periodCountryReport: newPeriodCountryReport });
            }
        }
    }

    handleFieldChange(event) {
        const { value,name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        API.BidderECost.get(filters).then(({ report }) => {
            const subidValues = this.getSubids(report);

            this.setState({ rawReport: report, daysReport: null, daysCountryReport: null, periodReport: null, periodCountryReport: null, subidValues, isLoading: false })
        });
    }

    getReport() {
        if(this.state.rawReport) {
            const { reportType } = this.state;

            if(reportType === 'days') return this.state.daysReport;
            if(reportType === 'daysCountry') return this.state.daysCountryReport;
            if(reportType === 'period') return this.state.periodReport;
            if(reportType === 'periodCountry') return this.state.periodCountryReport;
        }

        return null;
    }

    getSubids(report) {
        return report.reduce((arr, { subid }) => {
            if(!arr.includes(subid)) arr.push(subid);

            return arr;
        }, []);
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getTable() {
        const { subid, device, countries, sortParam, sortOrder, reportType } = this.state;
        const report = this.getReport();

        if(report) {
            if(reportType === 'days') return <DaysTable reportObj={report} subids={subid} device={device} countries={countries} sortParam={sortParam} sortOrder={sortOrder} onSortChange={this.handleSort}/>;
            if(reportType === 'daysCountry') return <DaysCountryTable reportObj={report} device={device} countries={countries} sortParam={sortParam} sortOrder={sortOrder} onSortChange={this.handleSort}/>;
            if(reportType === 'period') return <PeriodTable reportObj={report} subids={subid} device={device} countries={countries} sortParam={sortParam} sortOrder={sortOrder} onSortChange={this.handleSort}/>;
            if(reportType === 'periodCountry') return <PeriodCountryTable reportObj={report} device={device} countries={countries} sortParam={sortParam} sortOrder={sortOrder} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>;
    }

    render() {
        const { isLoading, affidValues, subidValues, subid, device, countries, reportType } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder ECost"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues}/>
                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={{ days: 'Days', daysCountry: 'Days Country', period: 'Period', periodCountry: 'Period Country' }}
                            label="ReportType:"
                            name="reportType"
                            onChange={this.handleFieldChange}
                            value={reportType}
                            required
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={{ '': 'All', 'm': 'Mobile', 'd': 'Desktop' }}
                            label="Device:"
                            name="device"
                            onChange={this.handleFieldChange}
                            value={device}
                            required
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={subid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="countries"
                            onChange={this.handleFieldChange}
                            value={countries}
                            multi
                            required
                        />
                    </Col>
                </Row>
                {this.getTable()}
            </Container>
        );
    }
}

export default BidderECost;


// WEBPACK FOOTER //
// ./src/scenes/BidderECost/index.js